// @flow

const shouldUseSecureToken = (protocol: string) => protocol === 'https:'

export const defaultCookieOptions = (protocol: string): Object => ({
  secure: shouldUseSecureToken(protocol),
  path: '/',
})
